export default __webpack_public_path__ + "static/media/KS1 days.bd593b68.jpg";